import React from 'react';

const ActiveIncidents = () => (
  <div className="text-white">Active Incidents Content</div>
  // Bạn có thể thay thế nội dung này bằng component chi tiết hơn
);

export default ActiveIncidents;